export enum InvitedCpStatus {
  INVITED = 'Invited',
  EXPIRED = 'Expired',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  RESUBMIT = 'Resubmission',
  REVOKED = 'Revoked'
}

export enum VerifiedCpStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum IncompleteCpStatus {
  INCOMPLETE = 'Incomplete'
}

export enum ActivityLogStatus {
  ONBOARDING = 'Onboarding',
  INVITATION = 'Invitation',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  RESUBMIT = 'Resubmission'
}
